import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { Notification, NotificationResponse } from "~types/notification.ts";

export const useMarkAsReadNotification = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  return useMutation<NotificationResponse, Error, string>({
    mutationFn: async (key: string) =>
      await request(`notifications/${key}/mark-as-read`, {
        method: "POST",
      }),
    onSuccess: (response: NotificationResponse, key: string) => {
      if (response?.data && response.data.length > 0) {
        queryClient.setQueryData(["notifications"], (oldNotifications: Notification[]) =>
          (oldNotifications || []).map((oldNotification) => (oldNotification.key === key ? response.data[0] : oldNotification)),
        );
        queryClient.invalidateQueries({ queryKey: ["user", "updates"] });
        refetchUserUpdates();
      }
    },
  });
};
